export const formatCpfView = (cpf: string): string => {
  const cleaned = cpf.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{3})(\d{2})$/);

  if (match) {
    return `${match[1]}.${match[2]}.${match[3]}-${match[4]}`;
  }

  return cpf;
};
export const formatCnpjView = (cnpj: string): string => {
  if (!cnpj) return '';
  const cleaned = cnpj.replace(/\D/g, '');
  const match = cleaned.match(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/);

  if (match) {
    return `${match[1]}.${match[2]}.${match[3]}/${match[4]}-${match[5]}`;
  }

  return cnpj;
};
export const formatCpfAndCnpj = (value: string): string => {
  if (!value) return '';
  if (value.length <= 11) {
    return formatCpfView(value);
  } else {
    return formatCnpjView(value);
  }
};

export const validadeCpf = (cpf: string): boolean => {
  if (!cpf) return false;
  const cleaned = cpf.replace(/[^\d]/g, '');

  if (cleaned.length !== 11 || /^(\d)\1+$/.test(cleaned)) return false;

  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cleaned.charAt(i)) * (10 - i);
  }
  let firstCheck = 11 - (sum % 11);
  if (firstCheck >= 10) firstCheck = 0;
  if (firstCheck !== parseInt(cleaned.charAt(9))) return false;

  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cleaned.charAt(i)) * (11 - i);
  }
  let secondCheck = 11 - (sum % 11);
  if (secondCheck >= 10) secondCheck = 0;
  if (secondCheck !== parseInt(cleaned.charAt(10))) return false;

  return true;
};

export const validadeCnpj = (cnpj: string): boolean => {
  if (!cnpj) return false;
  const cleaned = cnpj.replace(/[^\d]/g, '');

  if (cleaned.length !== 14 || /^(\d)\1+$/.test(cleaned)) return false;

  let sum = 0;
  let weight = 5;

  for (let i = 0; i < 13; i++) {
    const n = parseInt(cleaned.charAt(i));
    sum += n * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }

  let firstCheck = 11 - (sum % 11);
  if (firstCheck >= 10) firstCheck = 0;
  if (firstCheck !== parseInt(cleaned.charAt(12))) return false;

  sum = 0;
  weight = 6;

  for (let i = 0; i < 13; i++) {
    const n = parseInt(cleaned.charAt(i));
    sum += n * weight;
    weight = weight === 2 ? 9 : weight - 1;
  }

  let secondCheck = 11 - (sum % 11);
  if (secondCheck >= 10) secondCheck = 0;
  if (secondCheck !== parseInt(cleaned.charAt(13))) return false;

  return true;
};
